import { LampsOutlineIcon } from './LampsOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 7BDA9890-697C-4E97-A604-D34803DAAD39
 * name lamps-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lamps-outline.svg
 * tags
 * - Home Automation 
 */
export const LightsOutlineIcon = LampsOutlineIcon;
export default LightsOutlineIcon